(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["primevo-header-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('primevo-header-search'))customElements.define('primevo-header-search',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;this.events=new AbortController();
    const options={signal:this.events.signal},details=this.querySelector('details'),summary=this.querySelector('summary'),input=this.querySelector('input[type="search"]'),close=this.querySelector('.pv-search-close');
    close.hidden=false;
    const dismiss=restore=>{details.open=false;if(restore)summary.focus();};
    details.addEventListener('toggle',()=>{if(details.open){const menu=document.querySelector('.pv-mobile-menu');if(menu)menu.open=false;input.focus();}},{...options});
    close.addEventListener('click',()=>dismiss(true),options);
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&details.open){event.preventDefault();dismiss(true);}},options);
    document.addEventListener('click',event=>{if(details.open&&!this.contains(event.target))dismiss(false);},options);
  }
  disconnectedCallback(){this.events?.abort();this.bound=false;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["primevo-order-entry"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('primevo-add-to-cart'))customElements.define('primevo-add-to-cart',class extends HTMLElement{
  connectedCallback(){
    if(this.bound||!this.hasAttribute('data-keep-browsing'))return;
    this.bound=true;const form=this.querySelector('form'),button=form.querySelector('button[type="submit"]'),status=this.querySelector('[role="status"]');
    let pending=false;
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(pending||!form.reportValidity())return;
      pending=true;button.disabled=true;status.textContent=this.dataset.adding;this.setAttribute('aria-busy','true');
      try{
        const action=new URL(form.action,location.origin);action.pathname=action.pathname.replace(/\/$/,'')+'.js';
        const response=await fetch(action,{method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error('add_failed');
        status.textContent=this.dataset.added;
        try{
          const cartURL=new URL(this.dataset.cartUrl,location.origin);cartURL.pathname=cartURL.pathname.replace(/\/$/,'')+'.js';
          const cartResponse=await fetch(cartURL,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
          if(cartResponse.ok){const cart=await cartResponse.json();if(Number.isSafeInteger(cart.item_count)&&cart.item_count>=0)document.querySelectorAll('.pv-basket-count').forEach(count=>{count.textContent=String(cart.item_count);});}
        }catch{}
      }catch{status.textContent=this.dataset.error;}
      finally{pending=false;button.disabled=false;this.removeAttribute('aria-busy');}
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["primevo-public-catalogue"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('primevo-public-catalogue'))customElements.define('primevo-public-catalogue',class extends HTMLElement{
  async connectedCallback(){
    if(this.started)return;this.started=true;this.page=1;this.items=[];this.referenceHandles=new Set(JSON.parse(this.dataset.referenceHandles||'[]'));
    this.$=s=>this.querySelector(s);this.text=JSON.parse(this.$('[data-public-i18n]').textContent);
    this.form=this.$('form');const query=new URL(location.href).searchParams;this.form.elements.q.value=(query.get('pv_q')||query.get('q')||'').slice(0,120);this.form.addEventListener('submit',e=>e.preventDefault());
    this.form.addEventListener('input',()=>{clearTimeout(this.searchTimer);this.searchTimer=setTimeout(()=>{this.page=1;this.render();},120);});this.form.addEventListener('reset',()=>queueMicrotask(()=>{this.page=1;this.render();}));
    this.$('[data-public-prev]').onclick=()=>{this.page--;this.render();this.focusResults();};this.$('[data-public-next]').onclick=()=>{this.page++;this.render();this.focusResults();};
    this.$('[data-public-close]').onclick=()=>this.$('dialog').close();
    this.$('[data-public-retry]').onclick=()=>this.load();
    await this.load();
  }
  async load(){
    this.$('[data-public-retry]').hidden=true;
    this.$('[data-public-status]').textContent=this.text.loading;
    try{
      const urls=JSON.parse(this.dataset.urls);
      const parts=await Promise.all(urls.map(async path=>{
        const url=new URL(path,window.location.origin),controller=new AbortController();
        const timer=setTimeout(()=>controller.abort(),15000);
        try{
          const response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal});
          if(!response.ok)throw new Error('catalogue');
          const payload=await response.json();
          if(payload.version!==1||!Array.isArray(payload.rows)||typeof payload.imageBase!=='string')throw new Error('catalogue');
          return payload.rows.map(r=>{
            if(!Array.isArray(r)||r.length!==8)throw new Error('catalogue');
            return {handle:r[0],brand:r[1],reference:r[2],movement:r[3],gender:r[4],diameter:r[5],strap:r[6],image:r[7].startsWith('https://')?r[7]:payload.imageBase+r[7]};
          });
        }finally{clearTimeout(timer);}
      }));
      const data=parts.flat();
      const brandHandles={'montres-boss':'BOSS','montres-burberry':'Burberry','montres-festina':'Festina','montres-fossil':'Fossil','montres-gucci':'Gucci','montres-michael-kors':'Michael Kors','montres-seiko':'Seiko','montres-tissot':'Tissot','montres-tommy-hilfiger':'Tommy Hilfiger'};
      const h=this.dataset.handle,fixedBrand=brandHandles[h];this.items=data.filter(p=>p&&typeof p.handle==='string'&&typeof p.reference==='string'&&(!fixedBrand||p.brand===fixedBrand));
      const fixed={'montres-quartz':['movement','Quartz'],'montres-automatiques':['movement','Automatique'],'montres-bracelet-cuir':['strap','Cuir'],'montres-bracelet-acier':['strap','Acier'],'montres-homme':['gender','Homme'],'montres-femme':['gender','Femme'],'montres-mixtes':['gender','Mixte']}[h];
      if(fixed)this.items=this.items.filter(p=>fixed[0]==='strap'?(p.strap||'').split(' / ').includes(fixed[1]):p[fixed[0]]===fixed[1]);
      if(fixedBrand)this.$('[data-brand-field]').hidden=true;
      this.items.forEach(p=>{p.searchIndex=this.normalize(p.brand+' '+p.reference);});
      for(const key of ['brand','movement','strap','gender'])this.form.elements[key].length=1;
      for(const key of ['brand','movement','strap','gender'])for(const value of [...new Set(this.items.flatMap(p=>key==='strap'?(p.strap||'').split(' / '):[p[key]]).filter(Boolean))].sort()){
        const option=document.createElement('option');option.value=value;option.textContent=this.label(value);this.form.elements[key].append(option);
      }
      this.render();
    }catch{this.$('[data-public-status]').textContent=this.text.load_error;this.$('[data-public-retry]').hidden=false;}
  }
  focusResults(){const status=this.$('[data-public-status]');status.focus({preventScroll:true});status.scrollIntoView({block:'start',behavior:'auto'});}
  normalize(value){return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');}
  label(value){const keys={Quartz:'quartz',Automatique:'automatic',Cuir:'leather',Acier:'steel',Homme:'men',Femme:'women',Mixte:'unisex',Caoutchouc:'rubber',Textile:'textile',Titane:'titanium',Céramique:'ceramic',Silicone:'silicone',Résine:'resin',Acétate:'acetate',Plastique:'plastic',Synthétique:'synthetic',Acrylique:'acrylic'};return String(value).split(' / ').map(v=>this.text[keys[v]]||v).join(' / ');}
  node(tag,text,cls){const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n;}
  referenceHandle(p){return p.handle.replace(/^primevo-/,'');}
  hasReference(p){return this.referenceHandles.has(this.referenceHandle(p));}
  referenceUrl(p){const root=(window.Shopify?.routes?.root||this.dataset.root||'/').replace(/\/$/,'');return root+'/pages/wholesale-watches/'+encodeURIComponent(this.referenceHandle(p));}
  photo(p,link=false){
    const box=this.node(link?'a':'div',undefined,'pv-catalog-image');if(link){box.href=this.referenceUrl(p);box.setAttribute('aria-label',p.brand+' '+p.reference);}
    const img=this.node('img');img.src=p.image;img.alt=p.brand+' '+p.reference;img.loading='lazy';img.decoding='async';img.width=500;img.height=500;
    img.onerror=()=>{box.replaceChildren(this.node('span',this.text.image_pending));};box.append(img);return box;
  }
  render(){
    const f=this.form.elements,terms=f.q.value.trim().split(/\s+/).map(v=>this.normalize(v)).filter(Boolean);const filtered=this.items.filter(p=>{
      if(!terms.every(word=>p.searchIndex.includes(word)))return false;
      for(const key of ['brand','movement','strap','gender'])if(f[key].value&&(key==='strap'?!(p.strap||'').split(' / ').includes(f[key].value):p[key]!==f[key].value))return false;
      const size=f.diameter.value,d=p.diameter;if(size&&(d===null||d===undefined))return false;
      if(size==='under30'&&d>=30)return false;if(size==='45'&&d<45)return false;if(['30','35','40'].includes(size)&&(d<Number(size)||d>=Number(size)+5))return false;
      return true;
    });
    const pages=Math.max(1,Math.ceil(filtered.length/24));this.page=Math.max(1,Math.min(this.page,pages));
    this.$('[data-public-status]').textContent=filtered.length+' '+(filtered.length===1?this.text.reference:this.text.references);this.$('[data-public-page]').textContent=this.page+' / '+pages;
    this.$('[data-public-prev]').disabled=this.page<=1;this.$('[data-public-next]').disabled=this.page>=pages;
    const root=this.$('[data-public-products]');root.replaceChildren();
    if(!filtered.length)root.append(this.node('p',this.text.no_results,'pv-catalog-empty'));
    for(const p of filtered.slice((this.page-1)*24,this.page*24)){
      const card=this.node('article',undefined,'pv-catalog-card'),body=this.node('div',undefined,'pv-catalog-card-body');
      const heading=this.node('h2');if(this.hasReference(p)){const productLink=this.node('a',p.reference);productLink.href=this.referenceUrl(p);heading.append(productLink);}else heading.textContent=p.reference;
      body.append(this.node('p',p.brand,'pv-eyebrow'),heading,this.node('p',this.text.public_price,'pv-catalog-public-price'));
      const open=this.node('button',this.text.details,'pv-catalog-detail');open.type='button';open.append(this.node('span','↗'));open.onclick=()=>this.detail(p);body.append(open);card.append(this.photo(p,this.hasReference(p)),body);root.append(card);
    }
  }
  detail(p){
    const root=this.$('[data-public-detail]'),info=this.node('div');root.replaceChildren(this.photo(p),info);
    info.append(this.node('p',p.brand,'pv-eyebrow'),this.node('h2',p.reference));
    const dl=this.node('dl');for(const [key,label] of [['movement','mouvement'],['strap','bracelet'],['gender','genre'],['diameter','diametre']])if(p[key]!==null&&p[key]!==undefined){dl.append(this.node('dt',this.text[label]),this.node('dd',this.label(p[key])+(key==='diameter'?' mm':'')));}
    info.append(dl,this.node('p',this.text.public_price,'pv-catalog-public-price'));const login=this.node('a',this.text.login,'pv-button');login.href=this.dataset.login;info.append(login);
    const siteRoot=(this.dataset.root||'/').replace(/\/$/,'');
    const enquiry=this.node('a',this.text.request_availability,'pv-button');enquiry.href=siteRoot+'/pages/contact?'+new URLSearchParams({marque:p.brand,reference:p.reference});info.append(enquiry);
    if(this.hasReference(p)){const sheet=this.node('a',this.text.details,'pv-text-link');sheet.href=this.referenceUrl(p);info.append(sheet);}
    const apply=this.node('a',this.text.apply,'pv-text-link');apply.href=siteRoot+'/pages/devenir-partenaire';info.append(apply);
    this.$('dialog').showModal();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["primevo-search-form"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('primevo-search-form'))customElements.define('primevo-search-form',class extends HTMLElement{
  connectedCallback(){
    if(this.bound)return;this.bound=true;
    const form=this.querySelector('form'),input=form.elements.q,current=new URL(location.href);
    if(current.searchParams.has('pv_q'))input.value=current.searchParams.get('pv_q').slice(0,120);
    for(const name of ['pv_brand','pv_strap'])if(form.elements[name])form.elements[name].value=current.searchParams.get(name)||'';
    form.addEventListener('submit',event=>{
      if(!form.reportValidity())return;
      let term=input.value.trim();
      if(/^t\d{13}$/i.test(term))term=term.slice(0,4)+'.'+term.slice(4,7)+'.'+term.slice(7,9)+'.'+term.slice(9,12)+'.'+term.slice(12);
      const brand=form.elements.pv_brand?.value||'',strap=form.elements.pv_strap?.value||'';
      const escape=value=>'"'+value.replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'"';
      const conditions=[];
      if(term)conditions.push(term.split(/\s+/).map(escape).join(' AND '));
      if(brand)conditions.push('vendor:'+escape(brand));
      if(/^pv-bracelet-[a-z-]+$/.test(strap))conditions.push('tag:'+escape(strap));
      const url=new URL(form.action,location.origin);
      url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');
      url.searchParams.set('q',brand||strap?conditions.join(' AND '):term||'tag:"primevo-b2b"');
      url.searchParams.set('pv_q',input.value.trim());
      if(brand)url.searchParams.set('pv_brand',brand);if(strap)url.searchParams.set('pv_strap',strap);
      for(const key of ['country','locale','preview_theme_id'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
      event.preventDefault();location.assign(url.href);
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
